import { render, staticRenderFns } from "./OutstandingMember.vue?vue&type=template&id=01d61b9a&scoped=true"
import script from "./OutstandingMember.vue?vue&type=script&lang=js"
export * from "./OutstandingMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d61b9a",
  null
  
)

export default component.exports